<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listRegistrationsTypes"
        :title-table="$t('Registration Type')"
        module="registrationTypeSettingsModule"
        sort-name="nome"
        add-permission="ROLE_TIPO_REGISTRO_INSERIR"
        view-permission="ROLE_TIPO_REGISTRO_CONSULTAR"
        edit-permission="ROLE_TIPO_REGISTRO_ATUALIZAR"
        delete-permission="ROLE_TIPO_REGISTRO_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormRegistrationType
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormRegistrationType from './forms/FormRegistrationType.vue'

export default {
  name: 'RegistrationType',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormRegistrationType,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('registrationTypeSettingsModule', {
      listRegistrationsTypes: state => state.listRegistrationsTypes,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id',
        },
        {
          label: this.$t('Description'),
          field: 'nome',
        },
        {
          label: 'Tipo De Cadastro',
          field: 'tipo.nome',
        },
        {
          label: 'Categoria Padrão',
          field: 'tiposFaixaPadrao',
        },
        {
          label: 'Tipo Pagto. Padrão',
          field: 'tipoPagamentoPadrao.descricao',
        },
        {
          label: 'Conta Padrão',
          field: 'contaPadrao.descricao',
        },
        {
          label: this.$t('Active'),
          field: 'ativo',
        },
        {
          label: this.$t('Action'),
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'registrationTypeSettingsModule/prepareToEditRegistrationType',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
